import { createFileRoute } from "@tanstack/react-router"
import { ProductsGrid } from "@/features/products/ProductsGrid"

/**
 * Each filter is a comma-separated list of values rather than an array,
 * so the URL stays readable (`?gameSlug=lorcana,pokemon`) and links can
 * be constructed with plain strings without configuring a custom
 * `stringifySearch` on the router.
 */
export interface ProductsSearch {
	gameSlug?: string
	expansionSlug?: string
	productType?: string
	finishes?: string
	rarity?: string
	productCategory?: string
	languages?: string
	q?: string
}

const asString = (v: unknown): string | undefined =>
	typeof v === "string" && v.length > 0 ? v : undefined

export const Route = createFileRoute("/products/")({
	component: ProductsPage,
	validateSearch: (search: Record<string, unknown>): ProductsSearch => ({
		gameSlug: asString(search.gameSlug),
		expansionSlug: asString(search.expansionSlug),
		productType: asString(search.productType),
		finishes: asString(search.finishes),
		rarity: asString(search.rarity),
		productCategory: asString(search.productCategory),
		languages: asString(search.languages),
		q: asString(search.q),
	}),
})

function ProductsPage() {
	const search = Route.useSearch()
	return <ProductsGrid initialSearch={search} />
}
